var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomepageHeroWaveDesktop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1437 65"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1436.99 47.025c-26.63 9.647-58.86 14.709-88.05 16.094-3.8.18-78.13.438-83.21.03l-63.1-5.052-81.26-10.882c-108.93-15.944-218.229-26.478-328.5-30.613-75.36-2.82-150.21.04-224.9 8.64L464.787 37.14C337.061 51.858 168.715 52.437 45.388 16.811 29.472 12.217 14.556 7.045 0 0v64.993h1283.65c1.82.01 53.64.01 55.46 0H1437V47.025z"
})));
export default SvgHomepageHeroWaveDesktop;